module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/design-tile-images/design-tile-03-29942f25ca77e085cf0fd2f6396931b2.png";